import { Pipe, PipeTransform } from '@angular/core';
import { DprApprovalStatusSummaryReport } from '@report/models';
import { ApproveStatus } from '@shared/enums/dpr';
import { DprOnlineApproval } from '@shared/models/dpr';
import { SubprojectConfigurationCustomNames } from '@shared/models/project-setup';

@Pipe({
  name: 'approveStatusText',
})
export class ApproveStatusTextPipe implements PipeTransform {
  transform(
    data: DprOnlineApproval | DprApprovalStatusSummaryReport,
    customNames: SubprojectConfigurationCustomNames,
    property: string
  ): string {
    switch (data?.[property]) {
      case ApproveStatus.Accepted:
        return (
          customNames.approvalAcceptCustomName ??
          $localize`:@@dprs.approveStatusTextPipe.lblAccept:Accepted`
        );
      case ApproveStatus.Rejected:
        return (
          customNames.approvalRejectCustomName ??
          $localize`:@@dprs.approveStatusTextPipe.lblReject:Rejected`
        );
      case ApproveStatus.Seen:
        return (
          customNames.approvalSeenCustomName ??
          $localize`:@@dprs.approveStatusTextPipe.lblSeen:Seen`
        );
      case ApproveStatus.NotApproved:
        return (
          customNames.approvalNoActionCustomName ??
          $localize`:@@dprs.approveStatusTextPipe.lblNoAction:No Action`
        );
      default:
        return null;
    }
  }
}
